import { apiFetch } from '../config/api'
import type { TeamMember, TeamMemberRole, TeamMembersListResponse } from '../types/teamMember'

export async function fetchTeamMembers(
  projectId: string,
  params: { search?: string; role?: string; status?: string; page: number; pageSize: number }
): Promise<TeamMembersListResponse> {
  const q = new URLSearchParams({
    page: String(params.page),
    pageSize: String(params.pageSize)
  })
  if (params.search) q.set('search', params.search)
  if (params.role) q.set('role', params.role)
  if (params.status) q.set('status', params.status)
  return apiFetch<TeamMembersListResponse>(`/api/projects/${projectId}/team-members?${q}`)
}

export async function fetchTeamMember(projectId: string, memberId: string): Promise<TeamMember> {
  return apiFetch<TeamMember>(`/api/projects/${projectId}/team-members/${memberId}`)
}

export async function createTeamMember(
  projectId: string,
  body: {
    memberExternalId: string
    memberRole: TeamMemberRole
    name: string
    email: string
    phone: string
    jobTitle?: string
    status: 'active' | 'inactive'
    assignedEquipment: string[]
    plateSources: string[]
  }
): Promise<TeamMember> {
  return apiFetch<TeamMember>(`/api/projects/${projectId}/team-members`, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export async function updateTeamMember(
  projectId: string,
  memberId: string,
  body: Record<string, unknown>
): Promise<TeamMember> {
  return apiFetch<TeamMember>(`/api/projects/${projectId}/team-members/${memberId}`, {
    method: 'PUT',
    body: JSON.stringify(body)
  })
}

export async function deleteTeamMember(projectId: string, memberId: string): Promise<void> {
  await apiFetch<undefined>(`/api/projects/${projectId}/team-members/${memberId}`, {
    method: 'DELETE'
  })
}
